// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ProductCardFragmentDoc } from '../../layout/cards/ProductCard.generated';
import { ProductListAnalyticsFragmentDoc } from '../../../views/product/composables/analytics/useProductAnalytics.generated';
export const ProductGridFragmentDoc = gql`
    fragment productGrid on CatalogueProduct {
  ...productCard
  ...productListAnalytics
  ... on CatalogueEngagementRing {
    variationsByPrimaryMetal {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueWeddingRing {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryRing {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryBracelet {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryNecklace {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
  ... on CatalogueJewelleryEarrings {
    variations {
      ...productCard
      ...productListAnalytics
    }
  }
}
    ${ProductCardFragmentDoc}
${ProductListAnalyticsFragmentDoc}`;